(function() {
    'use strict';

    angular
        .module('app')
        .directive('xtoClear', xtoClear);

    xtoClear.$inject = ['$window', '$timeout'];
    
    function xtoClear($window, $timeout) {
        // Usage:
        //     <clear_input></clear_input>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            $timeout(function () {
                //get the input box height
                var inputHeight = element.css('height');

                //get the element's right padding
                var inputPadding = element.css('paddingRight');

                //calculate the vertical position the icon will be placed
                var topPosition = Math.round((parseInt(inputHeight)) / 2 - 7);

                if (topPosition < 0) {
                    topPosition = 4;
                }

                //Create the wrapper for the input
                var wrapper = angular.element('<div style="width:100%" class=""></div>');

                //create the icon
                var xIcon = angular.element('<i class="glyphicon glyphicon-remove"></i>');
                //default state of the icon
                xIcon.css('visibility', 'hidden');

                //add some padding if needed
                if (parseInt(inputPadding) < 25) {
                    element.css('paddingRight', '25px');
                }

                //bind the check to display to the focus event
                element.bind('focus', function (e) {
                    checkDisplay();
                });

                //bind to the blur to hide the icon when not in focus
                element.bind('blur', function (e) {
                    //enough time to click on it.
                    $timeout(function () {
                        xIcon.css('visibility', 'hidden');
                    }, 200)

                })

                //checks the input to see if its empty
                var checkDisplay = function () {
                    var visibility = element[0].value.length > 0 ? "visible" : "hidden";
                    xIcon.css('visibility', visibility);
                }

                //check whether is displayed or not after each input
                element.on('input', function (e) {
                    checkDisplay();
                });

                //set the position to relative for library controls (their parents have position absolute)
                if (!element.parent().hasClass('datacard-control')) {
                    wrapper.css('position', 'relative');
                    //add the wrapper before the input box
                    element.before(wrapper);
                    //add the input box
                    wrapper.append(element);
                    //add the icon
                    wrapper.append(xIcon);
                }
                else {
                    //for regular sized input boxes
                    element.parent().append(xIcon);
                }

                //memo
                if (element[0].id == "memo-input" || element.hasClass('normal-input')) {
                    topPosition = 10;
                }

                //set styles for the icon
                xIcon.css({
                    'position': 'absolute',
                    'z-index': '9999',
                    'right': inputPadding,
                    'top': topPosition + 'px',
                    'opacity': '0.6',
                    'padding': '1px',
                    'cursor': 'pointer',

                });

                //bind to the click event
                xIcon.on('click', function (e) {
                    element[0].value = "";
                    //propagate the input event to ensure ng-model is kept in sync
                    $(element).trigger('input');
                    //IE fix
                    angular.element(element).triggerHandler('change');

                    //get focus after clearing the contents.
                    element[0].focus();
                });
            });
        }
    }

})();